<template>
      <div class="wrapper wrapper-content">
        <div class="container-fluid">

<div class="">
              
  
  <div class="row member-credit">
    <div class="col-lg-12">





      <div class="tabs-container">

        <ul class="nav nav-tabs">
            <li style="background:#eaeaea">
               <router-link :to="{name: 'credit'}" class="no-margins text-center text-nowrap"><i class="fa fa-list-ol"></i> รายงานเครดิต</router-link>
            </li>
            <li class="active">
              <router-link :to="{name: 'credithistory'}" class="no-margins text-center "><i class="fa fa-history"></i> รายงานเครดิตย้อนหลัง</router-link>
            </li>
            <li style="background:#eaeaea">
              <a class="no-margins text-center text-nowrap" href="#">รายงานเครดิตจากระบบเก่า</a>
            </li>          
        </ul>



      <div class="tab-pane active">
        <div class="panel-body p-xs">
          <div class="table-responsive">

            <data-tables :data="creditRecords" :pagination-props="{ pageSizes: [10, 25, 50, 100] }" :table-props="tableProps">
              <el-table-column prop="index" label="เลขที่ทำรายการ" width="auto" sortable="custom">
              </el-table-column>
              <el-table-column prop="detail" label="รายละเอียด" width="auto">
                  <template slot-scope="scope">
                    <div v-html="scope.row.detail"></div>
                  </template>
              </el-table-column>
              <el-table-column prop="action" label="ผู้กระทำ" width="auto">
                  <template slot-scope="scope" >
                    <span class="label label-danger">{{ scope.row.action }}</span>
                  </template>
              </el-table-column>
              <el-table-column prop="fullname" label="กระทำกับ" width="auto">
                  <template slot-scope="scope" >
                    <div class="text-success">{{ scope.row.fullname }} </div>
                  </template>
              </el-table-column>
              <el-table-column prop="credit_total" label="เครดิต" width="auto">
                  <template slot-scope="scope" >
                      <div v-html="scope.row.credit_total"></div>
                  </template>
              </el-table-column>
              <el-table-column prop="balance_total" label="เครดิตคงเหลือ" width="auto">
              </el-table-column>
              <el-table-column prop="date_time" label="วันที่ทำรายการ" width="180" sortable="custom">
              </el-table-column>
              <el-table-column prop="desc" label="หมายเหตุ" width="300">
              </el-table-column>
             </data-tables>

          </div> <!-- /.table-responsive -->

                    <button v-if="okToLoadMore" @click="loadLedger" class="btn btn-primary"><i class="fa fa-chevron-down fa-fw"></i>
                        Load More
                    </button>

          <div class="row">
            <div class="col-sm-4"><div class="text-primary-new m-b-sm">อัพเดตล่าสุด {{ lastUpdate }} </div></div>
            <div class="col-sm-8">
              
              
  
  
    
  
  
    
  
  

            </div>
          </div>


        </div> <!-- /.ibox-content -->
      </div> <!-- /.ibox -->
    </div>
    </div> <!-- /.col-lg-12 -->
  </div> <!-- /.row -->

            </div>

        </div>
      </div><!-- /#page-wrapper -->

</template>

<script>
import { mapState } from 'vuex'
import moment from 'moment'

export default {
    name: 'credit',
    data () {
        return {
            creditRecords: [],
            isHidden: false,
            completedFirstPass: false,
            okToLoadMore: false,
            query: {
                sort: '',
                order: 'desc',
                page: 0,
                limit: 20,
                type: 'history',
            },
            lastUpdate: new Date().toLocaleString(),
            tableProps: {
                border: true,
                stripe: true,
                defaultSort: {
                    prop: 'index',
                    //order: 'descending'
                },
            },
        }
    },
    computed: {
        ...mapState({
            user: state => state.user.user
        }),
    },
    methods: {
        async loadLedger () {
            try {
                const response = await this.$store.dispatch('ledger/getUsersLedger', this.query)
                //console.log('async loadLedger', response)
 
                let items = response
                let dict = Object.create(null) // create an empty object

                let result = items.reduce(function(arr, o) {

                    //console.log('o.status_id 4 6', o.oh_status_id)
                    if ( o.oh_id ) {

                        if ( o.oh_status_id == 4 ) {
                            let current = dict[o.oh_id] // get the object from dict

                            if (!current) { // if dict doesn't contain object
                                current = Object.assign({}, o) // create a clone of the object - this prevents changing the original object
                                
                                arr.push(current) // push it to the array
                                
                                dict[o.oh_id] = current // add it to dict
                            }
                            else { // if dict contains the object
                                if ( o.credit ) {
                                    current.credit += o.credit
                                }

                                if ( o.balance < current.balance ) {
                                    current.balance = o.balance
                                }
                            }
                        }
                        else if ( o.oh_status_id == 3 ) {
                            //cancel status
                            if ( o.oi_id ) {
                                let current = dict[o.oh_id]
                                if (!current) { // if dict doesn't contain object
                                    current = Object.assign({}, o) // create a clone of the object - this prevents changing the original object
                                    
                                    arr.push(current) // push it to the array
                                    
                                    dict[o.oh_id] = current // add it to dict
                                }
                                else { // if dict contains the object
                                    if ( o.credit ) {
                                        current.credit += o.credit
                                    }

                                    if ( o.balance < current.balance ) {
                                        current.balance = o.balance
                                    }
                                }
                            }
                            else {
                                arr.push(o)
                            }
                        }
                        else if ( o.oh_status_id == 5 ) {
                            //paid status (win/notwin)
                            
                            if ( o.oi_id ) {
                                if ( o.oi_status_id == 6 ) {
                                    // not win
                                    //console.log('not win record', o.oh_id, o.oi_id , o.oh_status_id, o.credit, o.debit, o.oi_status_id, o.desc)
                                    let key = o.oh_id + o.desc
                                    let current = dict[key] // get the object from dict

                                    if (!current) { // if dict doesn't contain object
                                        current = Object.assign({}, o) // create a clone of the object - this prevents changing the original object
                                        
                                        arr.push(current) // push it to the array
                                        
                                        dict[key] = current // add it to dict
                                    }
                                    else { // if dict contains the object
                                        if ( o.debit ) {
                                            current.debit += o.debit
                                            if ( o.balance > current.balance ) {
                                                current.balance = o.balance
                                            }
                                        }

                                        if ( o.credit ) {
                                            current.credit += o.credit
                                            if ( o.balance < current.balance ) {
                                                current.balance = o.balance
                                            }
                                        }


                                    }
                                }
                                else if ( o.oi_status_id == 5 ) {
                                    //win
                                    //console.log('win record', o.oh_id, o.oi_id , o.oh_status_id, o.credit, o.debit, o.oi_status_id, o.desc)
                                    let key = o.oh_id + o.desc
                                    let current = dict[key] // get the object from dict
                                    
                                    if (!current) { // if dict doesn't contain object
                                        current = Object.assign({}, o) // create a clone of the object - this prevents changing the original object
                                        
                                        arr.push(current) // push it to the array
                                        
                                        dict[key] = current // add it to dict
                                    }
                                    else { // if dict contains the object
                                        if ( o.debit ) {
                                            current.debit += o.debit

                                            if ( o.balance > current.balance ) {
                                                current.balance = o.balance
                                            }
                                        }

                                        if ( o.credit ) {
                                            current.credit += o.credit
                                            if ( o.balance < current.balance ) {
                                                current.balance = o.balance
                                            }
                                        }

                                    }
                                }
                            }
                            else {
                                arr.push(o)
                            }
                        }
                        else if ( o.oh_status_id == 6 ) {
                            //closed status (not win)
                            if ( o.oi_id ) {

                                let current = dict[o.oh_id] // get the object from dict

                                if (!current) { // if dict doesn't contain object
                                    current = Object.assign({}, o) // create a clone of the object - this prevents changing the original object
                                    
                                    arr.push(current) // push it to the array
                                    
                                    dict[o.oh_id] = current // add it to dict
                                }
                                else { // if dict contains the object
                                    if ( o.credit ) {
                                        current.credit += o.credit
                                    }

                                    if ( o.balance < current.balance ) {
                                        current.balance = o.balance
                                    }
                                }

                            }
                            else {
                                arr.push(o)
                            }
                        }
                    }
                    else {
                        arr.push(o)
                    }

                    return arr
                }, [])
                //console.log('result', result)
                this.creditRecords = this.formatResultData(result)
                //console.log('result', this.creditRecords)
                this.getNow()

            } catch (error) {
                this.$toasted.error('There was an error connecting to the server.')
            } finally {
                if (this.completedFirstPass === false) { this.completedFirstPass = true }
            }
        },
        formatDate (value) {
            if (value) {
                let date = new Date(value)
                return moment(date).format('DD/MM/YYYY HH:mm:ss')
            }
        },
        formatUnixTime (value) {
            if (value) {
                let date = new Date(value)
                let unix_time = date.getTime() / 1000
                return unix_time
            }
        },
        formatResultData (raw_data) {
            let reformat_data = []
            for (let i = 0; i < raw_data.length; i++) {

                let credit_total_text = ''
                if ( raw_data[i].credit > 0 ) {
                    let credit = raw_data[i].credit * -1
                    credit_total_text = '<div class="text-negative">'+ credit +'</div>'
                          
                }
                else {
                    credit_total_text = '<div class="text-positive">'+ raw_data[i].debit +'</div>'
                }

                let temp_data = {
                    index:          i + 1,
                    detail:         this.detailMessage(raw_data[i]),
                    action:         'ระบบ',
                    fullname:       this.user.firstname + ' ' + this.user.lastname,
                    credit_total:   credit_total_text,
                    balance_total:  raw_data[i].balance,
                    date_time:      this.formatDate(raw_data[i].created_at),
                    desc:           raw_data[i].desc,

                }
                reformat_data.push( temp_data )
            }
            return reformat_data
        },
        detailMessage (order_data) {
            //console.log('order_data', order_data)
            let detailMessage = ''
            if (order_data.oh_id) {
                if ( order_data.debit > 0 ) {
                    // deposit money
                    if ( order_data.oh_status_id == 3 ) {
                        //cancel, return money
                        detailMessage = '<span class="label" style="color:#fff;background-color: red">ยกเลิก</span>'
                    }
                    else if ( order_data.oh_status_id == 5 ) {
                        //win, paid
                        detailMessage = '<span class="label" style="color:#fff;background-color: #ffbe00">ชนะเดิมพัน</span>'
                    }        
                    
                }
                else if ( order_data.credit > 0 ) {
                    // bet
                    detailMessage = '<span class="label" style="color:#fff;background-color: #4b8df8">แทงพนัน</span>'
                }
            }
            else {
                if ( order_data.debit > 0 ) {
                    // deposit money
                    detailMessage = '<span class="label" style="color:#fff;background-color: #090">เติมเครดิต</span>'
                    
                }
                else if ( order_data.credit > 0 ) {
                    // withdraw money
                    detailMessage = '<span class="label" style="color:#fff;background-color: #4b8df8">ถอนเครดิต</span>'
                }
            }
            return detailMessage
        },
        getNow () {
            let now = new Date()
            this.lastUpdate = moment(now).format('DD/MM/YYYY HH:mm:ss')
        },

    },
    mounted () {
    },
    created () {
        this.loadLedger()
    },
    destroyed () {
    }
}
</script>

<style lang="sass" scoped>
</style>
